export interface BusinessHour {
	start: moment.Moment;
	end: moment.Moment;
}

export enum Days {
	sunday = 'SUNDAY',
	monday = 'MONDAY',
	tuesday = 'TUESDAY',
	wednesday = 'WEDNESDAY',
	thursday = 'THURSDAY',
	friday = 'FRIDAY',
	saturday = 'SATURDAY',
}

export type Day =
	| Days.sunday
	| Days.monday
	| Days.tuesday
	| Days.wednesday
	| Days.thursday
	| Days.friday
	| Days.saturday;
